<style lang="scss" scoped>
  @import "../../../scss/app";

  .page-content {
    padding-left: 300px;
    overflow: auto;
    height: 100%;
  }
</style>

<template>
  <div class="full-height">

    <myo-sidebar>

      <div>
        <div class="text-grey pt3 pl3 pr3 pb1">Innstillinger</div>
        <router-link to="/app/settings/my-profile" class="myo-list-item">Min profil</router-link>
      </div>

    </myo-sidebar>

    <div class="page-content">
      <div class="p3">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
  import apiCart from '@/js/api/cart';
  import State from '@/js/helpers/state';
  import hasPrices from '@/js/mixins/hasPrices';

  export default {
    mixins: [hasPrices],

    data() {
      return {
        state: new State(),
        cart: null,
      };
    },

    mounted() {
      this.state.start('loading');
      apiCart.get().then(this.onCartSuccess);
    },

    methods: {
      onCartSuccess(cart) {
        apiCart.show(cart.id).then(this.onFetchSuccess);
      },

      onFetchSuccess(response) {
        this.$root.$data.cart = response.data.data;
        this.state.stop('loading');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Settings.vue?480bfff0